import React from "react";
import DynamicFieldConfigType from "../types/DynamicFieldConfigType";
import DynamicFieldLabel from "./DynamicFieldLabel";
import FormAssetUploadField from "../../fields/assetUploadField";
import { AssetType } from "../../../enums/AssetType";
import { AspectRatioRestrictionType, AssetInputMode, AssetUploadType } from "../../core/assetUpload/types";
import { useDynamicFormRenderer } from "../context/dynamicFormRendererContext";
import { DEFAULT_ASSET_CONFIG_RATIO_4_1 } from "shared/form/core/assetUpload/constants";
import { ImageAspectRatio } from "shared/form/core/assetUpload/enum";

/**
 * @name SingleImageFieldWrapper
 * @interface DynamicFieldConfigType
 * @param props
 * @constructor
 */

export default function SingleImageFieldWithAspectRatioWrapper(props: DynamicFieldConfigType) {
  const { registrationId, registrationParticipantId } = useDynamicFormRenderer();

  const assetConfig = React.useMemo(() => {
    // while refactoring this component full asset config will come from backend
    if (props.schemaObj.imageAspectRatio === ImageAspectRatio.RATIO_4_1) {
      return DEFAULT_ASSET_CONFIG_RATIO_4_1;
    }
  }, [props.schemaObj.imageAspectRatio]);

  const aspectRatioRestriction = React.useMemo(() => {
    // Restriction Type will also come from BE
    return AspectRatioRestrictionType.WARNING;
  }, []);

  return (
    <React.Fragment>
      <FormAssetUploadField
        name={props.schemaObj.id}
        label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
        assetType={AssetType.USER_INPUT}
        assetUploadType={AssetUploadType.IMAGE}
        disabled={props.schemaObj.disabled}
        required={props.schemaObj.mandatory}
        validate={props.validationFn}
        placeholder={props.schemaObj.placeholderLabel}
        registrationId={registrationId as string}
        registrationParticipantId={registrationParticipantId}
        assetInputMode={AssetInputMode.SINGLE}
        fullWidth={props.schemaObj.fullWidthView}
        indented={props.schemaObj.indented}
        assetConfig={assetConfig}
        aspectRatioRestriction={aspectRatioRestriction}
      />
    </React.Fragment>
  );
}
